import { createContext, useContext, useMemo, useState } from "react";

const appState = {
  error: undefined,
};

export const ApiErrorModalContext = createContext({
  apiErrorModalState: appState,
  setApiErrorModalState: () => undefined,
});
ApiErrorModalContext.displayName = "AppErrorModalContext";

export function ApiErrorModalProvider(props) {
  const [apiErrorModalState, setApiErrorModalState] = useState(appState);

  const value = useMemo(
    () => ({
      apiErrorModalState,
      setApiErrorModalState,
    }),
    [setApiErrorModalState, apiErrorModalState]
  );

  return <ApiErrorModalContext.Provider value={value} {...props} />;
}

export function useApiErrorModalContext() {
  const context = useContext(ApiErrorModalContext);

  if (!context) {
    throw new Error("useAppContext must be used within a AppProvider");
  }

  return context;
}
